import { render } from 'redity'
import {
    Empty,
    FormControl,
    FormControls,
    IterateOptions
} from '../../../../../components/FormUtilities'
import Option from '../../../../../components/Option'
import SelectTouch from '../../../../../components/SelectTouch'
import useStorage from '../../../../../hooks/useStorage'
import LogisticalConcept from '../../../../../models/LogisticalConcept'
import { Keys } from '../../../constants'
import { formCostByProduct, tableCostByProductControl } from '../storageStep3'

function Concept() {
    const { props, data, getError } =
        formCostByProduct.useSelect<LogisticalConcept>(
            'logistical_concept',
            '/v5.6/apis/search_logistical_concepts?is_enabled=true&non_logistical_concept_ids=1,2,3,4,5,6,7,8,9,10,11'
        )
    const helper2 = getError(
        'ERROR-0000102',
        'El concepto de pago ya está siendo usado en el formulario',
        'logistical_concept_id'
    )
    return (
        <FormControl label="Concepto" required col="span-3">
            <SelectTouch
                {...props}
                helper={props.helper || helper2}
                placeholder="Seleccionar concepto"
                disabled={formCostByProduct.store().logistical_cost_id !== null}
            >
                <IterateOptions data={data} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

function Currency() {
    const { props } = formCostByProduct.useSelect('currency')
    const { currencies } = useStorage()
    function handleChange(ev) {
        props.onChange(ev)
        tableCostByProductControl.renderMain()
        render(Keys.TABLE_DISTRIBUTION_BY_PRODUCT_SPECIFICATIONS)
        render(formCostByProduct.keyRender, 'cost')
        render(formCostByProduct.keyRender, 'exchange_to_local')
    }

    return (
        <FormControl label="Moneda" required col="span-3">
            <SelectTouch
                {...props}
                onChange={handleChange}
                placeholder="Seleccionar moneda"
            >
                {currencies.map(currency => (
                    <Option
                        value={currency.id.toString()}
                        label={`${currency.name} (${currency.symbol})`}
                        key={currency.id}
                    />
                ))}
                <Empty data={currencies} />
            </SelectTouch>
        </FormControl>
    )
}

export default function Selects() {
    return (
        <FormControls className="mb-4">
            <Concept />
            <Currency />
        </FormControls>
    )
}
